<template>
    <div 
        id="join"
    >
        <p class="my-4">
            Young people are at the heart of Youth Opportunities and it thrives on new ideas and courageous leadership to make a positive contribution in youth development. Self-motivated people who believe in YO’s global cause and are interested to be a part of the journey are welcome to join the team.
        </p>
        <p class="my-4">
            Are you excited to explore your full potential? At YO, we create a conducive platform for young people to educate, empower and engage them in leading innovative initiatives to make a difference in the society.
        </p>
        <p class="my-4">
            Exciting opportunities are coming for you to get connected with us! 
        </p>
    </div>
</template>

<script>
    export default {  
        name: 'Join'
    }
</script>